export const useConfig = () => {
    const termsUrl = import.meta.env.VITE_TERMS_URL || '#';
    const privacyPolicyUrl = import.meta.env.VITE_PRIVACY_POLICY_URL || '#';
    const loginUrl = import.meta.env.VITE_LOGIN_URL || '#';
    const publicMarketOnboardingKey = 'coamana_market_onboarding';
    const teamPhone = import.meta.env.VITE_TEAM_PHONE || '';
    const standardSubscriptionMonthlyPrice = import.meta.env.VITE_STANDARD_SUBSCRIPTION_MONTHLY_PRICE || 20000;
    const standardSubscriptionAnnualPrice = import.meta.env.VITE_STANDARD_SUBSCRIPTION_ANNUAL_PRICE || 200000;
    const enterpriseSubscriptionMonthlyPrice = import.meta.env.VITE_ENTERPRISE_SUBSCRIPTION_MONTHLY_PRICE || 50000;
    const paystackPublicKey = import.meta.env.VITE_PAYSTACK_PUBLIC_KEY || '';
    

    return {
        termsUrl,
        privacyPolicyUrl,
        loginUrl,
        publicMarketOnboardingKey,
        teamPhone,
        standardSubscriptionMonthlyPrice,
        standardSubscriptionAnnualPrice,
        enterpriseSubscriptionMonthlyPrice,
        paystackPublicKey
    }
}